import { createContext, useContext, useState } from "react";

const translations = {
  it: {
    "nav.storia": "La Nostra Storia",
    "nav.dettagli": "Dettagli",
    "nav.countdown": "Countdown",
    "nav.gallery": "Gallery",
    "nav.dono": "Il Vostro Dono",
    "entrance.invited": "Siete invitati alle nozze di",
    "entrance.open": "Apri l'invito",
    "hero.invited": "Siete cordialmente invitati al matrimonio di",
    "hero.quote": "Due cuori, un unico destino",
    "hero.scroll": "Scorri per scoprire di più",
    "story.eyebrow": "Un Momento Speciale",
    "story.title": "La Nostra Storia",
    "story.subtitle": "Il luogo dove il nostro per sempre ha avuto inizio",
    "story.caption": "St. Moritz, la promessa",
    "saveDate.label": "Salva la data",
    "date.full": "28 Dicembre 2026",
    "date.month": "Dicembre 2026",
    "date.weekday": "Lunedì",
    "details.eyebrow": "I Dettagli",
    "details.title": "Il Grande Giorno",
    "details.dateLabel": "Data",
    "details.ceremonyTitle": "Cerimonia",
    "details.ceremonyTime": "ore 11:30",
    "details.ceremonyDesc": "Il rito nuziale avrà luogo nella splendida cornice di Villa Gazzani",
    "details.lunchTitle": "Pranzo",
    "details.lunchTime": "ore 13:00",
    "details.lunchDesc": "Festeggeremo insieme con un pranzo raffinato presso la villa",
    "details.location": "Location",
    "details.openMaps": "Apri in Google Maps",
    "details.contacts": "Contatti",
    "countdown.eyebrow": "Il Conto alla Rovescia",
    "countdown.title": "Manca Poco",
    "countdown.subtitle": "Ogni secondo ci avvicina al giorno più bello della nostra vita",
    "countdown.days": "Giorni",
    "countdown.day": "Giorno",
    "countdown.hours": "Ore",
    "countdown.hour": "Ora",
    "countdown.minutes": "Minuti",
    "countdown.minute": "Minuto",
    "countdown.seconds": "Secondi",
    "countdown.second": "Secondo",
    "countdown.quote": "L'attesa del piacere è essa stessa il piacere",
    "gallery.eyebrow": "La Location",
    "gallery.subtitle": "Dove celebreremo il nostro amore",
    "gallery.caption": "Un luogo magico per un giorno indimenticabile",
    "gallery.alt1": "Villa Gazzani - Sala Ricevimenti",
    "gallery.alt2": "Villa Gazzani - Piscina",
    "gift.eyebrow": "Con Amore",
    "gift.title": "Il Vostro Dono",
    "gift.p1": "Abbiamo già costruito la nostra casa.",
    "gift.p2": "Ora sogniamo di costruire ricordi: ",
    "gift.p2highlight": "un viaggio insieme.",
    "gift.p3": "Se vorrete accompagnarci in questa avventura, ne saremo profondamente grati.",
    "gift.holder": "Intestatario",
    "gift.copy": "Copia IBAN",
    "gift.copied": "Copiato!",
    "gift.thanks": "Grazie di cuore per il vostro affetto",
    "footer.quote": "L'amore non consiste nel guardarsi a vicenda, ma nel guardare insieme nella stessa direzione.",
    "footer.love": "Con tutto il nostro amore",
    "nav.rsvp": "Conferma",
    "rsvp.eyebrow": "Fateci Sapere",
    "rsvp.title": "Ci Sarete?",
    "rsvp.subtitle": "Confermate la vostra presenza con un semplice messaggio: ci aiuterete a preparare tutto alla perfezione",
    "rsvp.yes": "Sì, ci sarò!",
    "rsvp.no": "No, non ci sarò",
    "rsvp.msgYes": "Ciao Jherli e Mirko! Confermo: sì, ci sarò al vostro matrimonio del 28 Dicembre 2026! Non vedo l'ora di festeggiare con voi.",
    "rsvp.msgNo": "Ciao Jherli e Mirko! Purtroppo non potrò esserci al vostro matrimonio del 28 Dicembre 2026. Vi faccio i miei migliori auguri!",
  },
  es: {
    "nav.storia": "Nuestra Historia",
    "nav.dettagli": "Detalles",
    "nav.countdown": "Cuenta Regresiva",
    "nav.gallery": "Galería",
    "nav.dono": "Su Regalo",
    "entrance.invited": "Están invitados a la boda de",
    "entrance.open": "Abrir la invitación",
    "hero.invited": "Están cordialmente invitados a la boda de",
    "hero.quote": "Dos corazones, un solo destino",
    "hero.scroll": "Desliza para descubrir más",
    "story.eyebrow": "Un Momento Especial",
    "story.title": "Nuestra Historia",
    "story.subtitle": "El lugar donde nuestro para siempre comenzó",
    "story.caption": "St. Moritz, la promesa",
    "saveDate.label": "Reserva la fecha",
    "date.full": "28 de Diciembre de 2026",
    "date.month": "Diciembre de 2026",
    "date.weekday": "Lunes",
    "details.eyebrow": "Los Detalles",
    "details.title": "El Gran Día",
    "details.dateLabel": "Fecha",
    "details.ceremonyTitle": "Ceremonia",
    "details.ceremonyTime": "11:30 h",
    "details.ceremonyDesc": "La ceremonia nupcial tendrá lugar en el espléndido marco de Villa Gazzani",
    "details.lunchTitle": "Almuerzo",
    "details.lunchTime": "13:00 h",
    "details.lunchDesc": "Celebraremos juntos con un almuerzo elegante en la villa",
    "details.location": "Lugar",
    "details.openMaps": "Abrir en Google Maps",
    "details.contacts": "Contactos",
    "countdown.eyebrow": "La Cuenta Regresiva",
    "countdown.title": "Falta Poco",
    "countdown.subtitle": "Cada segundo nos acerca al día más bello de nuestra vida",
    "countdown.days": "Días",
    "countdown.day": "Día",
    "countdown.hours": "Horas",
    "countdown.hour": "Hora",
    "countdown.minutes": "Minutos",
    "countdown.minute": "Minuto",
    "countdown.seconds": "Segundos",
    "countdown.second": "Segundo",
    "countdown.quote": "La espera del placer es en sí misma el placer",
    "gallery.eyebrow": "El Lugar",
    "gallery.subtitle": "Donde celebraremos nuestro amor",
    "gallery.caption": "Un lugar mágico para un día inolvidable",
    "gallery.alt1": "Villa Gazzani - Salón de Recepciones",
    "gallery.alt2": "Villa Gazzani - Piscina",
    "gift.eyebrow": "Con Amor",
    "gift.title": "Su Regalo",
    "gift.p1": "Ya hemos construido nuestra casa.",
    "gift.p2": "Ahora soñamos con construir recuerdos: ",
    "gift.p2highlight": "un viaje juntos.",
    "gift.p3": "Si quieren acompañarnos en esta aventura, les estaremos profundamente agradecidos.",
    "gift.holder": "Titular",
    "gift.copy": "Copiar IBAN",
    "gift.copied": "¡Copiado!",
    "gift.thanks": "Gracias de corazón por su cariño",
    "footer.quote": "El amor no consiste en mirarse el uno al otro, sino en mirar juntos en la misma dirección.",
    "footer.love": "Con todo nuestro amor",
    "nav.rsvp": "Confirmar",
    "rsvp.eyebrow": "Avísennos",
    "rsvp.title": "¿Estarán?",
    "rsvp.subtitle": "Confirmen su asistencia con un simple mensaje: nos ayudarán a preparar todo a la perfección",
    "rsvp.yes": "¡Sí, estaré!",
    "rsvp.no": "No podré estar",
    "rsvp.msgYes": "¡Hola Jherli y Mirko! Confirmo: sí, estaré en su boda del 28 de Diciembre de 2026. ¡No veo la hora de celebrar con ustedes!",
    "rsvp.msgNo": "¡Hola Jherli y Mirko! Lamentablemente no podré estar en su boda del 28 de Diciembre de 2026. ¡Les envío mis mejores deseos!",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = (key) => translations[lang][key] ?? translations.it[key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
